module.exports = __webpack_public_path__ + "static/FiraCode-f08fdb39cbf433548d343b4e4daf3ba1.ttf";